import { useTranslation } from 'react-i18next'

import { FormikForm } from '../../../Formik'
import { ProfileContactsWidgetCreateFormContent } from '../ProfileContactsWidgetCreateFormContent'

import {
  getHasPhoneContact,
  getValidationSchema,
} from './ProfileContactsWidgetCreateForm.utils'

import * as styles from './ProfileContactsWidgetCreateForm.module.css'

function ProfileContactsWidgetCreateForm({
  addTypes,
  existingTypes,
  initialValues,
  name,
  newContacts,
  onClick,
  onRemoveContact,
  onSelectItem,
  onSubmit,
}) {
  const { t } = useTranslation()

  const hasPhoneContact = getHasPhoneContact(newContacts)

  const validationSchema = getValidationSchema({ name, newContacts, t })

  return (
    <div className={styles.cell}>
      <FormikForm
        initialValues={initialValues}
        validateOnBlur={false}
        validateOnChange={hasPhoneContact}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        <ProfileContactsWidgetCreateFormContent
          addTypes={addTypes}
          existingTypes={existingTypes}
          initialValues={initialValues}
          name={name}
          newContacts={newContacts}
          onClick={onClick}
          onRemoveContact={onRemoveContact}
          onSelectItem={onSelectItem}
        />
      </FormikForm>
    </div>
  )
}

export default ProfileContactsWidgetCreateForm
